import React from 'react';
import $ from "jquery";
  const Accessibility = {

     init:function ()
    {
        //無障礙
        var tabindex = 1;
          $('a,div.dropdown-toggle,button.nav-link,input[type=\'text\'],input[type=\'password\'],button[role=\'button\'],input[type=\'button\'],button[type=\'submit\'],input[type=\'submit\'],#condensation,.gsc-search-button button').each(function () {

              this.setAttribute('tabIndex', tabindex);
            tabindex++;

        });


        //無障礙
        $('div.dropdown-toggle,#condensation').focus(function (e) {
            $(this).unbind('keypress');
            $(this).on('keypress', function (e) {
                onkeypress(e, this);
            });
        });

        function onkeypress(e, target) {
            if (e.which == 13) {
                $(target).click();
            }
        }


        //無障礙
        $('.for_accessibility').find('a').focus(function () {

            $(this).css('width', '150px');
            $(this).css('height', '30px');
        });
        //無障礙
        $('.for_accessibility').find('a').blur(function () {

            $(this).css('width', '1px');
            $(this).css('height', '1px');

        });
    },

    /**
     * 開始執行無障礙
     * */
      start:function () {
          var e = this;
        setTimeout(function () {
            e.init();
        }, 1000);
    }
}

export default Accessibility;